const env = process.env.NODE_ENV || "development";

const domainEnvironment = {
  development: {
        domainAdminSide: "http://localhost:3001",
        domainUserSide: "http://localhost:3000",
        domainName:"",
  },
  production: {
      domainAdminSide: "https://admin.thainguyen.cgis.asia",
      domainUserSide: "https://thainguyen.cgis.asia",
      domainName:"thainguyen.cgis.asia",
  },
};

module.exports = domainEnvironment[env];
